import { EditOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, Spin, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import UserContext from '../../context/user-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const ProveedorView = (props) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState();
  const { user } = useContext(UserContext);
  const [usuario, setUsuario] = useState();

  useEffect(() => {
    const loadModel = async () => {
      try {
        const response = await instanceRef.instance.get(`/proveedor/${id}`);
        if (response.data?.data) {
          const fields = response.data?.data;
          setModel({
            ...fields
          });
        }
      } catch (error) {
        errorHandler(error);
      }
      setLoading(false);
    };
    if (id && form) {
      loadModel();
    }
  }, [id, form]);

  useEffect(() => {
    form.resetFields();
  }, [model, form]);

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const loadUser = async () => {
    setLoading(true);
    if (user) {
      try {
        const response = await instanceRef.instance.get(
          `/perfil/cognito/${user.sub}`
        );
        if (response.data?.data) {
          setUsuario({
            ...response.data?.data
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    }

    setLoading(false);
  };

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Datos del Proveedor"
        style={{ textAlign: 'left' }}
        extra={
          user &&
          !(
            user['cognito:groups'][0] === 'ADMIN_SUCURSAL' &&
            usuario.grupo === 'ADMIN_SUCURSAL'
          ) && (
            <Tooltip title="Editar proveedor">
              <Button
                type="text"
                icon={<EditOutlined />}
                size="middle"
                onClick={() => props.history.push(`edit/${id}`)}
              />
            </Tooltip>
          )
        }
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div style={{ maxWidth: '500px' }}>
            <Form
              {...formItemLayout}
              initialValues={model}
              scrollToFirstError
              form={form}
              name="proveedor"
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item label="Nombre" name="nombre">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Web" name="web">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Dirección" name="direccion">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Mail" name="mail">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Teléfono1" name="telefono1">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Teléfono2" name="telefono2">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Teléfono3" name="telefono3">
                <Input disabled />
              </Form.Item>
            </Form>
          </div>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default ProveedorView;
